// src/components/Subscription/UpgradePrompt.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Subtilus upgrade prompt – iššoka dėl hearts / streak / XP limito.
 * type: 'hearts' | 'streak' | 'limit' | 'locked'
 */
export default function UpgradePrompt({ type = 'limit', onClose }) {
  const navigate = useNavigate();

  const configs = {
    hearts: {
      icon: '❤️',
      title: 'Baigėsi gyvybės!',
      desc: 'Premium vartotojai gauna greičiau atsinaujinančias gyvybes ir Streak Shield!',
      cta: 'Gauti Premium',
      color: '#FF4B4B',
      bg: 'linear-gradient(135deg, #FF4B4B, #FF9600)',
    },
    streak: {
      icon: '🔥',
      title: 'Apsaugok savo seriją!',
      desc: 'Su Premium galite apsaugoti savo streak – net jei praleistumėte dieną!',
      cta: 'Apsaugoti streak',
      color: '#FF9600',
      bg: 'linear-gradient(135deg, #FF9600, #FFC800)',
    },
    limit: {
      icon: '🤖',
      title: 'AI užklausų limitas pasiektas!',
      desc: 'Pagerinkite planą ir gaukite daugiau AI žaidimų kiekvieną dieną.',
      cta: 'Pagerinti planą',
      color: '#58CC02',
      bg: 'linear-gradient(135deg, #667eea, #764ba2)',
    },
    locked: {
      icon: '🔒',
      title: 'Šis žaidimas Premium!',
      desc: 'Atrakinkite 50+ žaidimų su Basic arba Premium planu.',
      cta: 'Atrakinti visus žaidimus',
      color: '#CE82FF',
      bg: 'linear-gradient(135deg, #CE82FF, #764ba2)',
    },
  };

  const c = configs[type] || configs.limit;

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(4px)' }}
      onClick={e => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div className="bg-white rounded-3xl shadow-2xl max-w-sm w-full overflow-hidden animate-bounce-in">
        {/* Colour header */}
        <div className="p-8 text-center text-white" style={{ background: c.bg }}>
          <div className="text-6xl mb-3">{c.icon}</div>
          <h2 className="text-2xl font-black mb-1">{c.title}</h2>
          <p className="text-sm opacity-90 font-semibold">{c.desc}</p>
        </div>

        {/* Plan comparison mini */}
        <div className="p-6">
          <div className="grid grid-cols-2 gap-3 mb-5">
            {[
              { label: 'Nemokamas', val: '2 / dieną', color: '#AFAFAF' },
              { label: 'Basic', val: '25 / dieną', color: '#58CC02' },
            ].map(p => (
              <div
                key={p.label}
                className="rounded-2xl p-3 text-center border-2"
                style={{ borderColor: p.color, background: `${p.color}10` }}
              >
                <p className="text-xs font-black uppercase" style={{ color: p.color }}>{p.label}</p>
                <p className="font-black text-gray-800 mt-1">{p.val}</p>
                <p className="text-xs text-gray-400 font-semibold">AI užklausos</p>
              </div>
            ))}
          </div>

          <button
            onClick={() => navigate('/subscription')}
            className="w-full py-4 rounded-2xl font-black text-white text-lg mb-3 transition-all hover:scale-105"
            style={{ background: c.bg, boxShadow: `0 6px 0 rgba(0,0,0,0.15)` }}
          >
            {c.cta} →
          </button>

          <button
            onClick={onClose}
            className="w-full py-2 rounded-2xl font-bold text-gray-400 text-sm hover:text-gray-600 transition"
          >
            Gal vėliau
          </button>
        </div>
      </div>
    </div>
  );
}
